import { createContext } from 'react';

export const modalZIndexContext = createContext<null | number>(null);
